import { paidTotal } from './money';

/** The seven billing steps (Naturals salon-admin billing flowchart). */
export const STEPS = [
  { id: 'identify', label: 'Customer', hint: 'Phone, ID or face' },
  { id: 'services', label: 'Services', hint: 'Pick services & stylist' },
  { id: 'bill', label: 'Created bill', hint: 'Check the bill' },
  { id: 'pay', label: 'Payment', hint: 'Cash or UPI' },
  { id: 'review', label: 'Review', hint: 'Manager confirms' },
  { id: 'approve', label: 'Approve', hint: 'Lock & invoice' },
  { id: 'deliver', label: 'Print & WhatsApp', hint: 'Receipt' },
];

export const STATUS_LABELS = {
  service_completed: 'New',
  customer_identified: 'Customer found',
  bill_draft: 'Draft',
  awaiting_payment: 'Awaiting payment',
  payment_received: 'Paid',
  under_review: 'Under review',
  approved: 'Approved',
  finalized: 'Invoiced',
  delivered: 'Delivered',
};

const EDITABLE = new Set(['service_completed', 'customer_identified', 'bill_draft', 'awaiting_payment']);
const PAID_ONWARD = new Set(['payment_received', 'under_review', 'approved', 'finalized', 'delivered']);

export function canEditServices(bill) {
  return EDITABLE.has(bill?.status);
}

export function isPaidOrLater(bill) {
  return PAID_ONWARD.has(bill?.status);
}

/** Furthest step this bill can be on, from its saved status. */
export function stepForBill(bill) {
  if (!bill) return 0;
  const status = bill.status;
  if (status === 'finalized' || status === 'delivered') return 6;
  if (status === 'under_review' || status === 'approved') return 5;
  if (status === 'payment_received') return 4;
  if (status === 'awaiting_payment') {
    const total = Number(bill.grand_total) || 0;
    return total > 0 && paidTotal(bill) >= total - 0.009 ? 4 : 3;
  }
  if (!bill.customer) return 0;
  const items = bill.items || [];
  const unpriced = items.some((i) => !(Number(i.unit_price) > 0));
  if (status === 'bill_draft' && items.length && !unpriced) return 2;
  return 1;
}
